// extracted by mini-css-extract-plugin
export default {"navigation-item":"navigation-item","hidden":"hidden","arrow-nav":"arrow-nav","cms-icon":"cms-icon","left":"left","right":"right"};